import PubSub from "underpub-js";

var ModalFull = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ModalFull',
	};

	$.extend(true, this.options, options);

};

ModalFull.prototype.init = function() {

	var self = this;

};

export default ModalFull;
